import { inject, Pipe, PipeTransform } from '@angular/core';
import { SelectorsService } from '_services/selectors.service';

@Pipe({
    name: 'packageSelectorName',
    pure: true
})
export class PackageSelectorNamePipe implements PipeTransform {
  ss = inject(SelectorsService);


  transform(keyId: string): string {
    const selector = this.ss.getSelector(keyId);
    return selector ? selector.label : '';
  }
}